import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useInformationPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(),
      '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"]': {
        paddingBottom: '5px',
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: '25px',
      },
    },
  })
);
